// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sample-mapper {
  display: flex;
  flex-direction: row;
  overflow: auto;
  flex-grow: 1;
}

.sample-mapper .graph {
  flex: 1 1 auto;
}

.sample-mapper .sample-mapper-controls {
  display: flex;
  flex-direction: column;
  overflow: auto;
  flex: 0 1 auto;
  align-self: stretch;
  background-color: #444;
  border-radius: 3px;
}

.sample-mapper .graph canvas.dragging {
  cursor: ew-resize;
}

.sample-mapper .graph canvas.moveable {
  cursor: move;
  cursor: grab;
  cursor: -webkit-grab;
  cursor: -moz-grab;
}

.sample-mapper .graph canvas.moveable:active {
  cursor: move;
  cursor: grabbing;
  cursor: -webkit-grabbing;
  cursor: -moz-grabbing;
}

.control-group.pointbuttons,
.control-group.relnote-buttons {
  flex-direction: row;
}
`, "",{"version":3,"sources":["webpack://./src/components/sample_mapper/styles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB","sourcesContent":[".sample-mapper {\n  display: flex;\n  flex-direction: row;\n  overflow: auto;\n  flex-grow: 1;\n}\n\n.sample-mapper .graph {\n  flex: 1 1 auto;\n}\n\n.sample-mapper .sample-mapper-controls {\n  display: flex;\n  flex-direction: column;\n  overflow: auto;\n  flex: 0 1 auto;\n  align-self: stretch;\n  background-color: #444;\n  border-radius: 3px;\n}\n\n.sample-mapper .graph canvas.dragging {\n  cursor: ew-resize;\n}\n\n.sample-mapper .graph canvas.moveable {\n  cursor: move;\n  cursor: grab;\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n}\n\n.sample-mapper .graph canvas.moveable:active {\n  cursor: move;\n  cursor: grabbing;\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n}\n\n.control-group.pointbuttons,\n.control-group.relnote-buttons {\n  flex-direction: row;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
